import React, {useState, useEffect, useContext} from 'react';
import './Status.css';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import useNotification from '../../../hooks/useNotification';
import CustomToolbar from 'components/CustomToolbar';

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

function CustomToolbarWithReload(props) {
    return (
        <CustomToolbar {...props}>
            <IconButton title='Ricarica dati' onClick={() => {props.getStatus()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
        </CustomToolbar>
    );
}

const StatusCell = (params) => {
    const formatDataInsToShow = (data) => {
        if(!data)return "";
        let dd = data.substring(6,8);
        let month = data.substring(4,6);
        let anno = data.substring(0,4);
        let hour = data.substring(8,10);
        let mins = data.substring(10,12);
        let ss = data.substring(12, 14);
        let sss = data.substring(14,17);
        //return `${dd}/${month}/${anno} ${hour}:${mins}:${ss}.${sss}`
        //return new Date(`${anno}-${month}-${dd}T${hour}:${mins}:${ss}.${sss}Z`).toUTCString();
        let dateToRender = new Date(`${anno}-${month}-${dd}T${hour}:${mins}:${ss}.${sss}Z`);
        return dateToRender.toLocaleString("it-IT")
    }

    return(
        <div>
            {params.field === 'dataIns' ? formatDataInsToShow(params?.row['dataIns']?.S) : params?.value}
        </div>
    )
}

function Status(props) {
    const auth = useContext(AuthContext);
        const { status, setStatus } = useContext(AppAuthGlobalVariables);
        const { notificationError } = useNotification();
    
        const [loading, setLoading] = useState(true);
        const [statusLoading, setStatusLoading] = useState(true);
    
        const columns = [
            {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Log Id', type: 'string', width: 150, align: 'right', headerAlign: 'right', renderCell: (params) => StatusCell(params), valueGetter: (params) => params?.S},
            {field: 'dataIns', headerClassName: 'header-cell datains', headerName: 'Data Inserimento', type: 'date', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => StatusCell(params), valueGetter: (params) => formatDataIns(params?.S), valueFormatter: (params) => formatDataForCSV(params)},
            {field: 'deviceId', headerClassName: 'header-cell device', headerName: 'Id Impianto', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => StatusCell(params), valueGetter: (params) => params?.S},
            {field: 'panel', headerClassName: 'header-cell panel', headerName: 'Id Fermata', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => StatusCell(params), valueGetter: (params) => params?.S},
            {field: 'status', headerClassName: 'header-cell status', headerName: 'Status', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => StatusCell(params), valueGetter: (params) => params?.S},
            {field: 'ipFrom', headerClassName: 'header-cell ipFrom', headerName: 'IP', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => StatusCell(params), valueGetter: (params) => params?.S}
        ]
    
        useEffect(() => {
            if(!status.length){
                getStatus();
            }else{
                setStatusLoading(false);
                setLoading(false);
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])
    
        useEffect(() => {
            if(!loading){
                getStatus();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [props.city])
    
        const getStatus = async() => {
            try {
                setLoading(true);
                setStatusLoading(true);
    
                const params = {
                    city: props.city
                };
    
                const axiosParams = {
                    url: '/get-status',
                    method: 'get',
                    baseURL: config.API_URL,
                    headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                    params
                };
    
                const response = await axios(axiosParams);
                setStatus(response.data.dataToReturn);
                setStatusLoading(false);
                setLoading(false);
            } catch (error) {
                if (error?.status === 401 || error?.status === 403) {
                    props.logOut();
                } else {
                    if (typeof error.response.data.errorMessage === 'string') {
                        notificationError(error.response.data.errorMessage);
                    } else {
                        notificationError('Oops, an error has occured');
                    }
                }
                setStatusLoading(false);
                setLoading(false);
            }
        }
    
        const formatDataIns = (data) => {
            if(!data)return "";
            let dd = data.substring(6,8);
            let month = data.substring(4,6);
            let anno = data.substring(0,4);
            let hour = data.substring(8,10);
            let mins = data.substring(10,12);
            let ss = data.substring(12, 14);
            let sss = data.substring(14,17);
            //return `${dd}/${month}/${anno} ${hour}:${mins}:${ss}.${sss}`
            //ritorna valore in timezone corrente
            let dataInsDate = new Date(`${anno}-${month}-${dd}T${hour}:${mins}:${ss}.${sss}Z`);
            //la timezone è sempre la corrente ma viene forzato ad esserre come un valore in utc
            return new Date(dataInsDate.getTime() + dataInsDate.getTimezoneOffset() * 1000 * 60);
        }
    
        const formatDataForCSV = (data) => {
            if(!data)return "";
            let dd = data.getDate().toString().padStart(2, "0");
            let month = (data.getMonth()+1).toString().padStart(2, "0");
            let anno = data.getFullYear();
            let hour = data.getHours().toString().padStart(2, "0");
            let mins = data.getMinutes().toString().padStart(2, "0");
            let ss = data.getSeconds().toString().padStart(2, "0");
            let sss = data.getMilliseconds().toString().padStart(3, "0");
            return `${dd}/${month}/${anno} ${hour}:${mins}:${ss}.${sss}`
        }
    
        return (
            <div className='component-container status'>
                <div className='component-card'>
                    <ThemeProvider theme={theme}>
                        <DataGridPremium
                            rows={status}
                            columns={columns}
                            className="status-table"
                            loading={statusLoading}
                            rowHeight={30}
                            getRowId={(row) => row.idEntita.S}
                            disableAggregation
                            disableRowGrouping
                            disableDensitySelector
                            disablePivoting
                            showToolbar
                            slots={{
                                toolbar: CustomToolbarWithReload,
                            }}
                            slotProps={{
                                toolbar: {
                                    elements: ['columns', 'filters', 'export', 'quickFilter'],
                                    getStatus,
                                    printOptions: { disableToolbarButton: true }, 
                                    csvOptions: { fileName: `status_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                                    excelOptions: { fileName: `status_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                                }
                            }}
                        />
                    </ThemeProvider>
                </div>
            </div>
        )
}

export default Status